<template>
  <vs-chip class="item-chip p-0 m-0">
    <div @click.stop="onClickItem(label)">
      <span class="label">{{label}}</span>
      <span class="px-2 cursor-pointer" @click.stop="onClickCloseItem(label)">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_26361_57113)">
            <path d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_26361_57113">
              <rect width="12" height="12" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
  </vs-chip>
</template>

<script>
export default {
  name: 'ItemChip',
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClickItem(item) {
      this.$emit("click", item);
    },
    onClickCloseItem(item) {
      this.$emit("close", item);
    },
  },
};
</script>

<style scoped lang="scss">
.item-chip {
  border-radius: 4px;
  background-color: #7E72F2;

  .label {
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
